import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { v_InventoryBus } from "./v_InventoryBus";
import { InventoryLocationXrefBus } from "./InventoryLocationXrefBus";
import { InventoryThresholdOverrideBus } from "./InventoryThresholdOverrideBus";
import { InventorySupplierXrefBus } from "./InventorySupplierXrefBus";
import { InventoryBus } from "./InventoryBus";
import { InventoryConsumablesBus } from "./InventoryConsumablesBus";
import { InventoryConsMatchesBus } from "./InventoryConsMatchesBus";
import { InventoryThresholdOverrideBranchBus } from "./InventoryThresholdOverrideBranchBus";
import { InventoryPartNbrsBus } from "./InventoryPartNbrsBus";
import { InventoryThresholdOverrideAlternative } from "./InventoryThresholdOverrideAlternative";

export class InventoryBusInputParams extends BaseBus
{
    constructor(data: InventoryBus) {
        super();
        this.inventoryData = data;

        this.inventoryLocations=[];
        this.inventoryThresholdOverrides=[];
        this.inventoryAlternatives =[];
        this.inventorySuppliers=[];
        this.deletedItems = [];
    }

    CID(): any {
        return this.inventoryData.inventoryId;
    }
    setId(id: any) {
        this.inventoryData.inventoryId = id;
    }
    initialize(data: InventoryBusInputParams) {
        super.initialize(data);
        this.inventoryData.insertDt = CommonFunctions.getDate(data.inventoryData.insertDt);
        this.inventoryData.updateDt = CommonFunctions.getDate(data.inventoryData.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: InventoryBusInputParams) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.inventoryData.insertDt = data.inventoryData.insertDt;
            this.inventoryData.insertUserId = data.inventoryData.insertUserId;
        }
        else {
            this.inventoryData.insertDt = dateNow;
            this.inventoryData.insertUserId = data.inventoryData.insertUserId;
        }

    }
    setBeforeSave() {
        this.inventoryData.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.inventoryData.insertDt);
        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
            this.inventoryData.updateUserId = userId;
        }
        else {
            this.inventoryData.insertDt = date;
            this.inventoryData.insertUserId = userId;
            this.inventoryData.updateUserId = userId;
        }
    }

    inventoryData: InventoryBus;

    inventoryLocations: InventoryLocationXrefBus[];
    inventoryThresholdOverrides: InventoryThresholdOverrideBus[];
    inventoryThresholdOverrideBranchs: InventoryThresholdOverrideBranchBus[];
    inventoryAlternatives: InventoryThresholdOverrideAlternative[];
    inventorySuppliers: InventorySupplierXrefBus[];

    inventoryConsumables: InventoryConsumablesBus[];
    inventoryConsMatches: InventoryConsMatchesBus[];
    inventoryPartNbrs: InventoryPartNbrsBus[];
    idsToBeCleared: string[];
}
